module.exports = __webpack_public_path__ + "static/why-content-image-6-c28f99354602d8153d2e8a5c13ea53dd.svg";